import { render, staticRenderFns } from "./Article4.vue?vue&type=template&id=3657055a&"
import script from "./Article4.vue?vue&type=script&lang=js&"
export * from "./Article4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports